import React, { useState } from "react";

function ApplianceRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How Does Our Appliance Removal Service Work?",
      content: `
Easy Booking Process! Give us a call to schedule your appliance removal. Provide your full name, address, preferred date and time, and the type of appliance you need removed. Let us know if it’s already unplugged. Our junk removal team will take care of the rest!
      `,
    },
    {
      title: "What areas do you serve? ",
      content: `
       We proudly provide appliance haul services in Campbell, Los Altos, Fremont, Palo Alto, Saratoga, East Palo Alto, Cupertino, Los Gatos, Mountain View, San Jose, Milpitas, Newark, Santa Clara, and Sunnyvale. We also serve surrounding areas and neighboring cities.
      `,
    },
    {
      title: "Do you offer eco-friendly disposal options?",
      content: `
       Yes! We recycle appliances and work with donation centers to ensure proper disposal. We also take hazardous materials into account and follow recycling efforts to protect the ozone layer.
      `,
    },
    {
      title: "How much does appliance removal cost? ",
      content: `
         Our pricing is transparent and based on factors like cubic feet and removal time. Additional costs may apply for certain items, but we always provide a free estimate.
        `,
    },
    {
      title: "Can you handle large or heavy appliances? ",
      content: `
         Absolutely! We specialize in large appliances like old refrigerators, washer and dryer disposal, and other heavy appliance removals. Our team ensures safe and proper way removal.
        `,
    },
    {
      title: "Do you offer same-day service?",
      content: `
           Yes, we provide same-day service and day service appointments based on availability.
          `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default ApplianceRemovalFAQs;
